import { RouteRecordRaw } from 'vue-router';
import { authGuard } from '../guards/authGuard.js';

export const blogRoutes: RouteRecordRaw[] = [
  {
    path: '/blog',
    name: 'BlogLayout',
    component: () => import('@/features/blog/layouts/BlogLayout.vue'),
    children: [
      {
        path: '',
        name: 'BlogList',
        component: () => import('@/features/blog/pages/BlogList.vue'),
        meta: {
          title: 'Blog - Plaza Muffler',
          description: 'Expert insights on auto repair, maintenance, and car care from Plaza Muffler professionals.',
          requiresAuth: false,
        }
      },
      {
        path: ':slug',
        name: 'BlogPost',
        component: () => import('@/features/blog/pages/BlogPost.vue'),
        meta: {
          requiresAuth: false,
        },
        // Props will be used for SEO meta tags
        props: true
      }
    ]
  },
  {
    path: '/admin/blog',
    name: 'BlogAdmin',
    component: () => import('@/features/blog/layouts/BlogAdminLayout.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['admin']
    },
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'BlogDashboard',
        component: () => import('@/features/blog/pages/admin/BlogDashboard.vue'),
        meta: {
          title: 'Blog Dashboard',
          requiresAuth: true,
          requiredRoles: ['admin'],
        }
      },
      {
        path: 'new',
        name: 'CreateBlog',
        component: () => import('@/features/blog/pages/admin/BlogEditor.vue'),
        meta: {
          title: 'Create New Blog Post',
          requiresAuth: true,
          requiredRoles: ['admin']
        }
      },
      {
        path: 'edit/:id',
        name: 'EditBlog',
        component: () => import('@/features/blog/pages/admin/BlogEditor.vue'),
        meta: {
          title: 'Edit Blog Post',
          requiresAuth: true,
          requiredRoles: ['admin']
        },
        props: true
      }
    ]
  }
]; 